import { Link } from "react-router-dom";
import { Scissors, Clock } from "lucide-react";

export default function Header() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-amber-500/15 bg-[#0d0d0e]/90 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-md items-center justify-between px-4 py-3 md:max-w-2xl lg:max-w-4xl">
        <button
          data-testid="header-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2"
        >
          <img
            src="/logo.png"
            alt="Logo Resenha dú Corte"
            className="h-10 w-10 rounded-full border border-amber-500/40 object-cover"
          />
          <span className="font-display text-xl text-amber-100">RESENHA DÚ CORTE</span>
        </button>
        <div className="flex items-center gap-3">
          <span className="hidden items-center gap-1.5 text-xs text-zinc-400 sm:flex">
            <Clock className="h-3.5 w-3.5 text-amber-400" />
            Ter–Sáb · 9h–20h
          </span>
          <Link
            data-testid="barber-area-link"
            to="/barbeiro"
            className="text-xs font-semibold text-zinc-500 transition-colors hover:text-amber-300"
          >
            Barbeiro
          </Link>
          <button
            data-testid="header-agendar-button"
            onClick={() => scrollTo("agendar")}
            className="rounded-full bg-amber-500 px-4 py-2 text-xs font-bold uppercase tracking-wider text-zinc-950 transition-colors hover:bg-amber-400"
          >
            Agendar
          </button>
        </div>
      </div>
    </header>
  );
}
